module.exports = __webpack_public_path__ + "img/Case_9.cb553836.jpg";